import {Injectable} from "@angular/core";
import {SocialLogin} from "@capgo/capacitor-social-login";
import {SocialLoginRequestDTO} from "../model/social-login-request.model";
import {UserService} from "./user.service";
import {NavController} from "@ionic/angular";
import {lastValueFrom} from "rxjs";
import {NavigationService} from "./navigation.service";
import {CommonService} from "./common.service";
import {AppTrackingTransparency} from "capacitor-plugin-app-tracking-transparency";
import {environment} from "src/environments/environment";
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SocialLoginService {

  private _partialUserInfo: Partial<SocialLoginRequestDTO> = {};

  constructor(private userService: UserService,
              private navigationService: NavigationService,
              private commonService: CommonService,
              private navController: NavController) {
  }

  get partialUserInfo() {
    return this._partialUserInfo;
  }

  reset() {
    this._partialUserInfo = {};
  }

  async init() {

    await SocialLogin.initialize({
      facebook: {
        appId: environment.facebookAppId,
        clientToken: environment.facebookClientToken
      },
      google: {
        // Web Client (quello che usi su Android o Web)
        webClientId: '689668954648-2sajrms53nqj4sre9msr7k42ru81ra52.apps.googleusercontent.com',
        // iOS Client — quello del GoogleService-Info.plist
        iOSClientId: '689668954648-tkc7eklnhaimvfmsp83ghvbuvt10u80t.apps.googleusercontent.com',
        // Server client: in genere è quello Web
        iOSServerClientId: '689668954648-2sajrms53nqj4sre9msr7k42ru81ra52.apps.googleusercontent.com',
        mode: 'online'
      }
    });

  }

  async loginWithGoogle() {

    try {

      await SocialLogin.logout({provider: 'google'});
    } catch (error) {

      console.error("loginWithGoogle-logout");
      alert(JSON.stringify(error));
    }

    try {

      this.commonService.onToggleMainLoader();

      const res = await SocialLogin.login({
        provider: 'google',
        options: {
          scopes: ['email', 'profile'],
        },
      });

      const result: any = res?.result;

      this._partialUserInfo = {
        email: result?.profile?.email,
        name: result?.profile?.familyName,
        lastName: result?.profile?.givenName,
        provider: 'GOOGLE',
        username: result?.profile?.id,
        token: result?.profile?.id
      };

      await this._completeLogin();
      this.commonService.onToggleMainLoader();


    } catch (error) {

      console.error("loginWithGoogle", error);
      this.commonService.onToggleMainLoader();
      this.showErrorAlert();

    }

  }

  async loginWithApple() {

    try {

      const res$ = await SocialLogin.login({
        provider: 'apple', options: {
          scopes: ['email', 'profile'],
        }
      });

      this._partialUserInfo = {
        email: res$?.result?.profile?.email,
        name: res$?.result?.profile?.givenName,
        lastName: res$?.result?.profile?.familyName,
        provider: 'APPLE',
        username: res$?.result?.profile?.user,
        token: res$?.result?.profile?.user
      };

      await this._completeLogin();
      this.commonService.onToggleMainLoader();

    } catch (e) {

      console.error("loginWithApple", e);
      this.commonService.onToggleMainLoader();
      this.showErrorAlert();

    }


  }

  async loginWithFacebook() {

    await SocialLogin.logout({provider: 'facebook'});

    try {

      if (this.commonService.isIos()) {
        await this.richiediConsensoTracciamento();
        await new Promise(resolve => setTimeout(resolve, 500)); // 0.5s
      }

      console.log("richiediConsensoTracciamento");

      const res = await SocialLogin.login({
        provider: 'facebook',
        options: {
          permissions: ['email', 'public_profile'],
        },
      });

      console.log("loginWithFacebook", res);

      const result: any = res?.result;
      const email = _.isNil(result?.profile?.email) || _.isEmpty(result?.profile?.email)
        ? undefined
        : result.profile.email;

      this._partialUserInfo = {
        email,
        name: result?.profile?.name,
        provider: 'GOOGLE',
        username: result?.profile?.userID,
        token: result?.profile?.userID
      };

      await this._completeLogin();

    } catch (e) {

      console.error("loginWithFacebook", e);
      this.commonService.onToggleMainLoader();
      this.showErrorAlert();

    }

  }

  private async showErrorAlert() {
    this.commonService.presentAlertMsg('Errore', 'Ci scusiamo per il disagio, ma al momento non è possibile completare l’operazione. Ti invitiamo a riprovare più tardi.');
  }

  private async _completeLogin() {

    try {

      await lastValueFrom(this.userService.registerSocial(this.partialUserInfo));
      this.navigationService.closeModal();

      if (this.navigationService.navigationAfterLogin) {
        this.navigationService.useNavigationAfterLogin()
      } else {
        this.navController.navigateForward(['/tabs/home']);
      }

    } catch (e: any) {

      console.error("_completeLogin", e);

      if (e.error?.status == 400 && e.error?.message == 'SOCIAL_LOGIN_NOT_FOUND') {
        this.commonService.presentAlertMsg('Completa la registrazione', 'Per continuare, inserisci tutte le informazioni richieste.');
        this.navigationService.forwardModal('register_social');
      } else {

        this.showErrorAlert();

      }

    }

  }

  async richiediConsensoTracciamento() {
    // Questo codice verrà eseguito solo su piattaforme che lo supportano (iOS 14+)
    try {
      const {status} = await AppTrackingTransparency.requestPermission();

      console.log('Stato ATT:', status);
      // 'authorized': L'utente ha accettato.
      // 'denied': L'utente ha rifiutato.
      // 'restricted': L'autorizzazione è limitata (es. per controlli parentali).
      // 'notDetermined': L'utente non ha ancora preso una decisione.

      // Non devi fare nulla con lo 'status' per il login di Facebook.
      // L'SDK di Facebook rileverà automaticamente se il consenso è stato dato.

    } catch (error) {
      console.error('Errore durante la richiesta di consenso ATT:', error);
    }
  }

}
